import React, { useState } from 'react';
import css from './AppointmentScheduler.css';
import classNames from 'classnames';
import { useAppointmentSchedulerContext } from './AppointmentScheduler';
import AppointmentSchedulerModal from './AppointmentSchedulerModal';

const AppointmentSchedulerContent = props => {
    const {
        appointmentFetchError,
        modalContentType,
        toggleModal,
        handleModalTypeChange,
        handleFormSubmit,
        currentListing,
        isCustomer,
        customerName,
        providerName,
        intl,
    } = props;

    const { appointmentSchedulerModalVisible } = useAppointmentSchedulerContext();
    // const [tooltipVisible, setTooltipVisibility] = useState(false);
    // const [isTooltipWithBtnOpened, setIsTooltipWithBtnOpened] = useState(true);

    // useOutsideClick(['tooltip'], () => setTooltipVisibility(false));

    // const handleClickBtnTooltip = () => {
    //     handleTooltipVisibility(false);
    //     setIsTooltipWithBtnOpened(false);
    // };

    // const tooltipContentConfig = {
    //     [TOOLTIP_IS_PENDING]: (
    //         <div className={css.tooltipInfo}>
    //             <h5>
    //                 <FormattedMessage id="AppointmentScheduler.appointmentTooltipHeadingPending" />
    //             </h5>
    //             <p>
    //                 <FormattedMessage id="AppointmentScheduler.appointmentTooltipInfoPending" />
    //             </p>
    //         </div>
    //     ),
    //     [TOOLTIP_IS_ACTIVE]: (
    //         <div className={css.tooltipInfo}>
    //             <h5>
    //                 <FormattedMessage id="AppointmentScheduler.appointmentTooltipHeading" />
    //             </h5>
    //             <p>
    //                 <FormattedMessage
    //                     id={
    //                         isCustomer
    //                             ? 'AppointmentScheduler.appointmentTooltipInfo'
    //                             : 'AppointmentScheduler.appointmentTooltipInfoProvider'
    //                     }
    //                 />
    //             </p>
    //             <button
    //                 id="btn-tooltip"
    //                 onClick={handleClickBtnTooltip}
    //                 data-role={TOOLTIP_DATA_REQUEST_ATTR}
    //             >
    //                 <FormattedMessage id="AppointmentScheduler.appointmentTooltipCloseButton" />
    //             </button>
    //         </div>
    //     ),
    // };

    // const tooltipContent = tooltipContentConfig[tooltipContentType];
    /** if appointment has already been sent,
     * the error message is shown inside AppointmentMessage component
     */

    // const errorsMaybe = !hasPendingAppointment && (appointmentFetchError || appointmentError);

    return (
        <>
            {/* <Tooltip
                id="tooltip"
                content={
                    (tooltipContentType !== 'pending' && isTooltipWithBtnOpened) ||
                    tooltipContentType === 'pending'
                        ? tooltipContent
                        : ''
                }
                rootClassName={css.tooltipWrapper}
                tooltipClassName={
                    tooltipContentType !== 'pending'
                        ? css.tooltipContent
                        : css.tooltipContentPending
                }
                staticTooltipState={
                    tooltipContentType !== 'pending'
                        ? !errorsMaybe && tooltipIsOpened
                        : tooltipVisible
                }
                outsideClickHandler={handleTooltipVisibility}
                suppressOutsideClick={tooltipContentType === TOOLTIP_IS_ACTIVE}
                isStatic
            >
                {renderAppointmentActionElement({
                    ...appointmentActionElementProps,
                    handleAppointmentActionElementClick: appointmentActionElementProps.onClick,
                })}
                {errorsMaybe && <span className={css.appointmentError}>{errorsMaybe}</span>}
            </Tooltip> */}

            {/* {renderAppointmentActionElement({
                inProgress: sendAppointmentInProgress,
                disabled: appointmentFetchError || sendAppointmentInProgress,
                handleAppointmentActionElementClick: () => {
                    handleAppointmentRequest();
                    // setTooltipVisibility(true);
                },
            })} */}

            {appointmentSchedulerModalVisible && (
                <AppointmentSchedulerModal
                    modalContentType={modalContentType}
                    appointmentFetchError={appointmentFetchError}
                    modalIsOpen
                    toggleModal={toggleModal}
                    currentListing={currentListing}
                    isCustomer={isCustomer}
                    customerName={customerName}
                    providerName={providerName}
                    handleModalTypeChange={handleModalTypeChange}
                    handleFormSubmit={handleFormSubmit}
                    intl={intl}
                />
            )}
        </>
    );
};

export default AppointmentSchedulerContent;
